module.exports = __webpack_public_path__ + "static/media/img_1.2e167154.jpg";